module.exports = __webpack_public_path__ + "img/riskIndicatorScore.06ee7d3f.png";